module.exports = __webpack_public_path__ + "static/media/LIQUIDITY_LIGHT_M.6f16a75d.png";